import cn from 'clsx';

import { IconProps } from './types';

export const PlusIcon: React.FC<IconProps> = ({
  className,
  strokeWidth = 2,
}) => (
  <svg
    stroke="currentColor"
    className={cn('h-6 w-6', className)}
    fill="none"
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);
